import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { coreService } from 'network-utils';
import { selectToken } from '@redux/slices/userSlice';
import { useGetChallengeTeamsLeaderboard } from '@queries/core/challenges';
import { SmallLoader } from 'learning-panel-components';
import TeamLeaderboard, { TeamData } from './challengeTeamLeaderboard';
import styles from './userLeaderboard/loader.module.scss';

const TeamLeaderboardContainer: FC<{ challengeUuid?: string }> = (props: { challengeUuid?: string }) => {
    const { challengeUuid } = props;
    const token = useSelector(selectToken);
    const [allTeams, setAllTeams] = useState<TeamData[]>([]);
    const [myTeams, setMyTeams] = useState<TeamData[]>([]);
    const [teamsUsersDataOpen, setTeamsUsersDataOpen] = useState<{ [teamUuid: string]: boolean }>({});
    const { data, isLoading } = useGetChallengeTeamsLeaderboard(token, challengeUuid);

    const mapTeams = (teams: coreService.TeamLeaderboard[]): TeamData[] => {
        return teams.map((team: coreService.TeamLeaderboard) => ({
            uuid: team.uuid,
            rank: team.rank,
            teamName: team.name,
            score: Number(team.points),
            profilePicture: '',
            teamMembers: team.membersCount,
            usersCount: team.usersCount
        }));
    };

    useEffect(() => {
        if (!data) return;
        const { myTeams, allTeams } = data.teamsLeaderboard;
        setMyTeams(mapTeams(myTeams));
        setAllTeams(mapTeams(allTeams));
    }, [data]);

    const onChangeOpenMode = (teamUuid: string, teamType: string) => {
        const myTeamsOpenDataTemp = { ...teamsUsersDataOpen };
        myTeamsOpenDataTemp[`${teamUuid}-${teamType}`] = !(
            Object.prototype.hasOwnProperty.call(myTeamsOpenDataTemp, `${teamUuid}-${teamType}`) &&
            myTeamsOpenDataTemp[`${teamUuid}-${teamType}`]
        );
        setTeamsUsersDataOpen({ ...myTeamsOpenDataTemp });
    };

    return isLoading ? (
        <SmallLoader size="100px" className={styles.loader} />
    ) : (
        allTeams && (
            <TeamLeaderboard
                onLoadMore={() => undefined}
                hasMore={false}
                teams={allTeams}
                myTeams={myTeams}
                onChangeOpenMode={onChangeOpenMode}
                teamsUsersOpenState={teamsUsersDataOpen}
                challengeUuid={challengeUuid}
            />
        )
    );
};

export default TeamLeaderboardContainer;
